import {
  Outlet, useLocation, Link,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Components
import {
  ButtonMenu,
  Page,
// @ts-ignore
} from '@zolteam/zol-admin-ui';
// Misc
// eslint-disable-next-line import/no-unresolved
import Logo from '../../assets/logo-small-white.svg?react';
// service
import { useAuth } from '../../domain/auth/useAuth';

/**
 *
 * @returns {JSX.Element}
 */
function Layout() {
  // Hooks
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { logout } = useAuth();

  // const
  const menuEntries = [{
    label: '',
    entries: [
      {
        label: t('layout.menu.entries.customers'),
        href: '/customers',
        icon: 'profile',
      },
      {
        label: t('layout.menu.entries.bookings'),
        href: '/bookings',
        icon: 'calendar',
      },
      {
        label: t('layout.menu.entries.airports'),
        href: '/airports',
        icon: 'calendar',
      },
    ],
  }];

  // API calls

  // Handlers
  const handleLogout = () => {
    logout();
  };

  return (
    <Page
      pathname={pathname}
      Link={Link}
      menus={menuEntries}
      navigationLabel={t('layout.menu.foldAction')}
      logo={<Link to="/"><Logo width={200} /></Link>}
      footer={(
        <ButtonMenu
          icon="logout"
          color="alert"
          onClick={handleLogout}
        >
          {t('layout.logout')}
        </ButtonMenu>
      )}
      version={import.meta.env.VITE_APP_VERSION}
    >
      <Outlet />
    </Page>
  );
}

export default Layout;
